export enum ModalType {
  MainNavigation,
  Profile,
  TaskDetail,
}
